






























import { Component, Vue } from 'vue-property-decorator';
import { InspirationProductImage } from '@/models/Inspiration';
import { HtmlImageContainer } from '@/models/Image';

@Component
export default class MasonryGrid extends Vue {
    protected items: HtmlImageContainer[] = [] as HtmlImageContainer[];
    protected inspirationItems!: InspirationProductImage[];
    protected cols!: {};
    constructor() {
        super();
        if (this.$attrs['data-content']) this.items = JSON.parse(this.$attrs['data-content']);

        this.inspirationItems = JSON.parse(this.$attrs['data-inspiration']);
        const colsData = this.$attrs['data-cols'];
        if (colsData) {
            const cols = JSON.parse(colsData);
            this.cols = cols;
        } else {
            this.cols = { default: 2, 900: 1 };
        }
    }
}
